import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MaterialModule } from './material-module/material.module';

import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { SuccessPageComponent } from './pages/success-page/success-page.component';
import { TracingPageComponent } from './pages/tracing-page/tracing.component';
import { FailedPageComponent } from './pages/failed-page/failed-page.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { SuccessComponent } from './components/success/success.component';
import { FailedComponent } from './components/failed/failed.component';
import { ServicePageComponent } from './pages/service-page/service-page.component';
import { TimelineComponent } from './components/timeline/timeline.component';
import { DeviceComponent } from './components/device/device.component';
import { StartComponent } from './components/start/start.component';
import { PersonalComponent } from './components/personal/personal.component';
import { AddressComponent } from './components/address/address.component';
import { ServiceValidationComponent } from './components/service-validation/service-validation.component';
import { ServiceDataComponent } from './components/service-data/service-data.component';
import { DeviceHistoryComponent } from './components/device-history/device-history.component';
import { LayoutPageComponent } from './pages/layout-page/layout-page.component';
import { LogoToolbarComponent } from './components/logo-toolbar/logo-toolbar.component';
import { InfoToolbarComponent } from './components/info-toolbar/info-toolbar.component';
import { DeviceViewComponent } from './components/device-view/device-view.component';

import { ExternalService } from './services/external.service';
import { MSSPService } from './services/mssp.service';
import { InterceptorService } from './services/interceptor.service';
import { OncreateDirective } from './services/oncreate.directive';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { WhatsappComponent } from './components/whatsapp/whatsapp.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LanguagePluginComponent } from './components/language-plugin/language-plugin.component';
import { DialogMessageComponent } from './components/dialog-message/dialog-message.component';
import { MatDialogModule }  from '@angular/material/dialog';
import { MasGarantiaModule } from './mas-garantia-module/mas-garantia-module.module';




export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HomePageComponent,
    SuccessPageComponent,
    TracingPageComponent,
    FailedPageComponent,
    SideMenuComponent,
    SuccessComponent,
    FailedComponent,
    ServicePageComponent,
    TimelineComponent,
    DeviceComponent,
    StartComponent,
    PersonalComponent,
    AddressComponent,
    ServiceValidationComponent,
    ServiceDataComponent,
    DeviceHistoryComponent,
    LayoutPageComponent,
    LogoToolbarComponent,
    InfoToolbarComponent,
    DeviceViewComponent,
    OncreateDirective,
    SpinnerComponent,
    WhatsappComponent,
    BreadcrumbComponent,
    LanguagePluginComponent,
    DialogMessageComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FontAwesomeModule,
    MaterialModule,
    MasGarantiaModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      defaultLanguage: 'es-ES'
    }),
    MatDialogModule
  ],
  exports: [
    CommonModule,
    TranslateModule
  ],
  providers: [
    ExternalService,
    MSSPService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    }

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
export class SharedModule { }

